import webinarTracking from './webinars/webinar-register';

webinarTracking();
